<template>
    <div>
        <p class="tip">输入或粘贴ID或包名，每行一个</p>
        <el-input v-model="input" type="textarea" :rows="12"/>
        <div class="btns">
            <el-button @click="hideModal">取消</el-button>
            <el-button type="primary" :loading="loading" @click="onSubmit">提交</el-button>
        </div>
    </div>
</template>

<script>
    import {uniq} from "lodash";

    export default {
        props: ['cbs', 'appList', 'ids'],
        data() {
            return {
                input: '',
                loading: false,
                checkMax: 50
            }
        },
        methods: {
            hideModal(){
                this.$emit('close');
            },
            onSubmit() {
                const list = this.input.split(/\n/).filter(v=>v.trim()).map(v=>v.trim());
                if (!list.length) {
                    this.$message.error('请输入或粘贴ID或包名');
                    return;
                }
                this.loading = true;
                let successList = [];
                let successListItem = []
                let errorList = [];
                list.forEach(item=>{
                    let actionApp = this.appList.find(app=>app.app_id==item||app.package_name==item);
                    if(actionApp){
                        successList.push(actionApp);
                        successListItem.push(item)
                    }else{
                        errorList.push(item);
                    }
                });
                let uniq_errList = uniq(errorList)
                let uniq_sucList = uniq(successList)

                console.log('--', uniq_sucList, this.input)
                if (errorList.length>0) {
                    this.$confirm(`未找到以下产品，请检查输入的ID/包名是否准确，是否需要剔除未找到的产品？<p>${uniq_errList.join('、')}</p>`, '提示', {
                        confirmButtonText: '剔除',
                        cancelButtonText: '关闭',
                        dangerouslyUseHTMLString: true,
                        customClass: 'error-modal-max-height',
                        type: 'error'
                    }).then(() => {
                        let ids_len = this.ids.length
                        let suc_len = uniq_sucList.length
                        let max_len = Number(ids_len) + Number(suc_len)
                        if(max_len > this.checkMax) {
                            this.$message.error(`最多支持选择50个，当前选择了${max_len}个`);

                            this.input = successListItem.join('\n')


                            this.loading = false;
                            return;
                        }

                        this.cbs.onSubmit(uniq_sucList);
                        this.hideModal();
                    }).catch(() => {
                        this.loading = false;
                    })
                }else {
                    let ids_len = this.ids.length


                    let suc_len = uniq_sucList.length
                    let max_len = Number(ids_len) + Number(suc_len)
                    if(max_len > this.checkMax) {
                        this.$message.error(`最多支持选择50个，当前选择了${max_len}个`);

                        this.input = successListItem.join('\n')

                        this.loading = false;
                        return;
                    }
                    this.cbs.onSubmit(uniq_sucList);
                    this.cbs.onSubmit(successList);
                    this.hideModal();
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    .btns {
        margin-top: 25px;
        text-align: center;
    }

</style>
<style lang="scss">
.error-modal-max-height{
    .el-message-box__message{
        max-height: 60vh;
        overflow: auto;
    }
}
</style>
